import styled from "styled-components";

export const ContentCheckBoxDefaultStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;